<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('externalUser.production.payment') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
           <b-col lg="4" sm="12" md="4">
              <ValidationProvider name="User Type" vid="user_type" rules="">
                <b-form-group
                    class="row"
                    label-cols-sm="12"
                    label-for="user_type"
                    slot-scope="{ valid, errors }"
                    >
                    <template v-slot:label>
                    {{$t('externalUser.production.user_type')}}
                    </template>
                    <b-form-select
                    plain
                    v-model="search.user_type"
                    id="user_type"
                    :options="userTypeList"
                    value-field="value"
                    text-field="name"
                    :state="errors[0] ? false : (valid ? true : null)"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                    <div class="invalid-feedback">
                        {{ errors[0] }}
                    </div>
                </b-form-group>
              </ValidationProvider>
          </b-col>
           <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="date_form"
                  >
                      <template v-slot:label>
                          {{$t('globalTrans.from_date')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.date_form"
                          placeholder="Select Date"
                          id="date_form"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="to_date"
                  >
                      <template v-slot:label>
                          {{$t('globalTrans.to_date')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.to_date"
                          placeholder="Select Date"
                          id="to_date"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="receive_date"
                  >
                      <template v-slot:label>
                          {{$t('retailerManagement.receive_date')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.receive_date"
                          placeholder="Select Date"
                          id="receive_date"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="receive_id"
                  >
                      <template v-slot:label>
                          {{$t('externalUser.production.receive_id')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.receive_id"
                          id="receive_id"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="delivery_order_id"
                  >
                      <template v-slot:label>
                          {{$t('retailerManagement.delivery_order_id')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.delivery_order_id"
                          id="delivery_order_id"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="voucher_no"
                  >
                      <template v-slot:label>
                          {{$t('externalUser.voucher_no')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.voucher_no"
                          id="voucher_no"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="transaction_no"
                  >
                      <template v-slot:label>
                          {{$t('externalUser.transaction_no')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.transaction_no"
                          id="transaction_no"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="4">
              <b-button type="button" style="margin-top:36px" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
              </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('externalUser.production.payment_list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-payment @click="resetId">
                <i class="fas fa-plus"></i>{{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-tr-class="bg-primary" thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(user_type)="data">
                        {{ getUserType(data.item.user_type) }}
                    </template>
                    <template v-slot:cell(user_name)="data">
                        <span v-if="data.item.user_type < 3">
                        {{ getNameDealerName(data.item.user_type, data.item.user_id) }}
                      </span>
                      <span v-else>
                        {{ getNameDealerName(data.item.user_type, data.item.sales_center_id) }}
                      </span>
                    </template>
                    <template v-slot:cell(receive_id)="data">
                        {{ data.item.user_type == 1 || data.item.user_type == 2 ? data.item.delivery_rec_main?.receive_id : data.item.sc_delivery_rec_main?.receive_id }}
                    </template>
                    <template v-slot:cell(bank_name)="data">
                        {{ getBankName(data.item.bank_id) }}
                    </template>
                    <template v-slot:cell(pay_status)="data">
                        <span :class="(data.item.pay_status === 'success') ? `badge badge-success` : `badge badge-warning`">{{ data.item.pay_status }}</span>
                    </template>
                    <template v-slot:cell(created_at)="data">
                          {{ data.item.created_at | dateFormat }}
                    </template>
                    <template v-slot:cell(amount)="data">
                          {{ $n(data.item.amount) }}
                    </template>
                   <template v-slot:cell(action)="data">
                      <a href="javascript:" class="btn_table_action btn_green" v-b-modal.modal-detail @click="details(data.item)" :title="$t('globalTrans.details')"><i class="fas fa-eye"></i></a>
                      <a href="javascript:" class="btn_table_action btn_purple" v-if="data.item.payment_type_id === 2 && data.item.pay_status === 'pending'" :title="$t('retailerManagement.payment_verify')" v-b-modal.modal-verify @click="details(data.item)"><i class="fas fa-check-circle"></i></a>

                      <a href="javascript:" v-if="org_type || role_id" class="btn_table_action btn_blue" v-b-modal.payment-edit @click="details(data.item)" :title="$t('globalTrans.edit')"><i class="ri-ball-pen-fill"></i></a>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="lg" :title="$t('externalUser.payment_details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId"/>
    </b-modal>
   <b-modal id="modal-verify" size="lg" :title="$t('retailerManagement.payment_verify')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <PaymentVerify :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-payment" size="lg" :title="$t('externalUser.order_payment')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Payment />
    </b-modal>
    <b-modal id="payment-edit" size="lg" :title="$t('externalUser.order_payment')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <PaymentEdit :id="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import { Paymentlist } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import DetailModal from './DetailModal'
import Payment from './addPayment'
import PaymentEdit from './editPayment'
import PaymentVerify from './PaymentVerify.vue'
import flatpickr from 'flatpickr'
export default {
  mixins: [ModalBaseMasterList],
   components: {
    DetailModal,
    Payment,
    PaymentEdit,
    PaymentVerify
  },
  data () {
     return {
      search: {
        user_type: 0,
        is_user: 0,
        date_form: '',
        to_date: '',
        receive_date: '',
        receive_id: '',
        delivery_order_id: '',
        transaction_no: '',
        voucher_no: ''
      },
      org_type: this.$store.state.Auth.authUser.is_org_admin,
      role_id: this.$store.state.Auth.activeRoleId,
      bankList: [],
      optionsTypeList: [
            { value: 1, text_en: 'Dealer', text_bn: 'ডিলার' },
            { value: 2, text_en: 'Retailer', text_bn: 'খুচরা বিক্রেতা' },
            { value: 3, text_en: 'Sales Center', text_bn: 'বিক্রয় কেন্দ্র' }
        ],
      editItemId: ''
    }
  },
  computed: {
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    }),
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('externalUser.production.user_type'), class: 'text-center' },
          { label: this.$t('sales_distribution_admin.company_name'), class: 'text-center' },
          { label: this.$t('externalUser.production.receive_id'), class: 'text-center' },
          { label: this.$t('externalUser.bank_name'), class: 'text-center' },
          { label: this.$t('externalUser.voucher_no'), class: 'text-center' },
          { label: this.$t('externalUser.amount'), class: 'text-center' },
          { label: this.$t('externalUser.payment_date'), class: 'text-center' },
          { label: this.$t('externalUser.transaction_no'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'user_type' },
          { key: 'user_name' },
          { key: 'receive_id' },
          { key: 'bank_name' },
          { key: 'voucher_no' },
          { key: 'amount' },
          { key: 'created_at' },
          { key: 'transaction_no' },
          { key: 'pay_status' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'user_type' },
          { key: 'user_name' },
          { key: 'receive_id' },
          { key: 'bank_name' },
          { key: 'voucher_no' },
          { key: 'amount' },
          { key: 'created_at' },
          { key: 'transaction_no' },
          { key: 'pay_status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    userTypeList: function () {
        return this.optionsTypeList.map(item => {
            return Object.assign({}, item, { name: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
        })
    }
  },
  created () {
    this.getAllBank()
    this.loadData()
  },
  mounted () {
     flatpickr('#date_form', {})
     flatpickr('#to_date', {})
     flatpickr('#receive_date', {})
  },
  methods: {
    details (item) {
      this.editItemId = item.id
    },
    searchData () {
        this.loadData()
    },
    async getAllBank () {
        const bankList = await RestApi.getData(commonServiceBaseUrl, 'common/bank-list-all')
        this.bankList = bankList
    },
    loadData () {
        const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
        this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
        RestApi.getData(productionServiceBaseUrl, Paymentlist, params).then(response => {
            if (response.success) {
              this.$store.dispatch('setList', response.data.data)
              this.paginationData(response.data)
            }
            this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
        })
    },
    getBankName (id) {
        const bank = this.bankList.find(item => item.value === id)
        if (bank !== undefined) {
          if (this.$i18n.locale === 'bn') {
              return bank.text_bn
          } else {
              return bank.text_en
          }
        } else {
          return ''
        }
    },
    getNameDealerName (userType, id) {
        let user
        if (userType <= 2) {
            user = this.productCommonObj.dealerRetailerList.find(product => product.value === id)
        } else {
            user = this.$store.state.commonObj.officeList.find(product => product.value === id)
        }
        if (typeof user !== 'undefined') {
            if (this.$i18n.locale === 'bn') {
            return user.text_bn
            } else {
                return user.text_en
            }
        } else {
            return ''
        }
    },
    getPaymentStatus (status) {
        const Status = this.$store.state.ExternalUser.commonObj.paymentStatusList.find(item => item.value === status)
        if (this.$i18n.locale === 'bn') {
            return Status.text_bn
        } else {
            return Status.text_en
        }
    },
    getUserType (typeId) {
       const type = this.optionsTypeList.find(item => item.value === parseInt(typeId))
       if (type !== undefined) {
         return this.$i18n.locale === 'en' ? type.text_en : type.text_bn
       } else {
        return ''
       }
    }
  }
}
</script>
<style scope='css'>
  .blink_me {
    animation: blinker 1.3s linear infinite;
    color: red;
  }
  @keyframes blinker {
    50% {
      opacity: .09;
      background-color: green;
    }
  }
</style>
